import axios from 'axios'
import emitter from '../utils/emitter'

import { FORM_ACTIONS } from './formValidation'

export default {
  name: 'newsletter-form',

  options: {
    localesKey: 'newsletterForm',
    endpoint: 'https://statement.bigyouth.fr/api/newsletter/submit',
    method: 'POST',
  },

  ui: {
    input: '[js-newsletter-form-input]',
    trapInput: '[js-newsletter-form-trap-input]',
    successLabel: '[js-newsletter-form-success]',
    errorLabel: '[js-newsletter-form-error]',
  },

  componentDidMount () {
    emitter.on(FORM_ACTIONS.SUBMIT, this.handleFormSubmit)
  },

  handleFormSubmit (options) {
    if (this.props.formId === options.formId) {
      axios({
        url: this.options.endpoint,
        method: this.options.method,
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          email: this.ui.input.value,
          language: this.props.lang.toUpperCase(),
        },
      })
        .then(this.handleFormSuccess.bind(this))
        .catch(this.handleFormError.bind(this))
    }
  },

  handleFormSuccess (res) {
    this.ui.input.value = ''
    this.ui.successLabel.classList.remove('is-hidden')
    this.ui.errorLabel.classList.add('is-hidden')
  },

  handleFormError (res) {
    this.ui.successLabel.classList.add('is-hidden')
    this.ui.errorLabel.classList.remove('is-hidden')
  },
}
